/* Hook encargado de hacer la consulta a la base y 
traer la cotizacion a partir de su id

Autor: Benjamín León
Fecha: 2024-08-16
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import EstimateDto from '../interfaces/EstimateDto.ts'
import { normalizeDate } from '../utils/utils.ts'

import { makeUrlEstimateCrea } from './connectionData.tsx'
const apiUrl = makeUrlEstimateCrea()

const useEstimateVoid = () => {
  const [errorEstimateCrea, setErrorEstimateCrea] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const estimateCrea = async (estimate: EstimateDto): Promise<string | null> => {
    setLoading(true)

    try {
      const estimateNew = {
        ...estimate,
        date: normalizeDate(estimate?.date),
        expiresAt: normalizeDate(estimate?.expiresAt),
      }

      const res = await customPost<{ _id: string }>(apiUrl, estimateNew)

      setErrorEstimateCrea(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorEstimateCrea(err)
      } else {
        setErrorEstimateCrea(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorEstimateCrea, loading, estimateCrea }
}
export default useEstimateVoid
